import { FormState } from '../../models';
import { basicInfo } from './basic.info';
import { configureAlarms } from './alarms';
import { dataDelivery } from './data-delivery';
import { echoInfo } from './echo-info';
import { echoLongRange } from './sensors/long-range';
import { dialogActions } from './dialog-actions';
import { EchoLocationCardState } from './models';
import { advanced } from './advanced';
import { Config } from 'app/shared/services/config';

/**
 * Echo form configuration
 */
export const echoFormState = (state: EchoLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'echo-location-config',
                title: 'Echo Location Configuration',
            },
            sections: [
                basicInfo(state),
                echoInfo(state),
                echoLongRange(state),
                configureAlarms(state),
                dataDelivery(state),
                advanced(state),
                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
}
